import { message } from '../../../messages'

export const openPhoneSupport = () => {
  const phoneNumber = `tel:${message('messages.supportPhoneNumber').replace(/\D+/g, '')}`
  window.open(phoneNumber, '_blank')
}
